import { TextFilterType } from '../../../../../types';
import { TeamClientStatus } from '../../../../../main/teams/teamsTypes';

export type UniversalFilterCompanyStatusStatus = TeamClientStatus;

export const enum UniversalFilterCompanyStatusModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterCompanyStatusValue = TextFilterType;

export type UniversalFilterCompanyStatusFilterState = {
  mode: UniversalFilterCompanyStatusModes;
  statuses?: UniversalFilterCompanyStatusStatus[];
};

export type UniversalFilterCompanyStatusOnFilterStateChange = (
  state: UniversalFilterCompanyStatusFilterState
) => void;

export type UniversalFilterCompanyStatusOnChange = (
  value?: UniversalFilterCompanyStatusValue
) => void;
